<div class="switcher" data-qa="switcher" [ngClass]="{ active: active, disabled: disabled }">
  <div class="dot"></div>
</div>
